import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      '& .MuiDialog-paper': {
        maxWidth: theme.spacing(129), // 1032px
      },
    },
    wrapper: {
      padding: theme.spacing(3),
    },
    content: {
      paddingTop: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: theme.spacing(4),
    },
    formGroup: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    formLabel: {
      margin: 0,
      '& .Mui-checked': {
        color: theme.palette.primary.main,
      },
      paddingBottom: theme.spacing(0.5),
    },
    action: {
      justifyContent: 'flex-end',
      gap: theme.spacing(1.5),
    },
  })
);
